import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SignUp } from "../../assets/comman/index";
import { FaEye, FaEyeSlash } from "react-icons/fa"
import axios from "axios";
const Base_Url = process.env.REACT_APP_BASE_URL;
export default function SignupPage() {
  const navigate = useNavigate();
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const [formData, setFormData] = useState({
    name: "",
    address: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    gender:"",
  });

  const [errors, setErrors] = useState({}); 

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" })); 
  };

  const validate = () => {
    let newErrors = {};
    const { name,address, email, mobile, password, confirmPassword, gender } = formData;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    if (!name)  newErrors.name = "Name is required";
    if (!emailRegex.test(email)) newErrors.email = "Please enter a valid email address.";
    if (!mobileRegex.test(mobile)) newErrors.mobile = "Mobile number must be exactly 10 digits.";
    if (!address) newErrors.address = "Address is required";
    if(!passwordRegex.test(password)) newErrors.password="Password must be at least 8 characters long, contain 1 uppercase letter, 1 number, and 1 special symbol.";
    if (password !== confirmPassword) {
      newErrors.confirmPassword="Passwords do not match.";
    }
    if(!gender) newErrors.gender="Gender is required";
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validate();
  if (Object.keys(validationErrors).length === 0) {
    try{
      const CustomerData = new FormData();
      CustomerData.append("name", formData.name);
      CustomerData.append("email", formData.email);
      CustomerData.append("mobileNumber", formData.mobile);
      CustomerData.append("gender", formData.gender);
      CustomerData.append("address", formData.address);
      CustomerData.append("role", "CUSTOMER");
      CustomerData.append("password", formData.password);
      CustomerData.append("isBlock", "false");
      
      const res = await axios.post(`${Base_Url}/api/auth/register`, CustomerData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    toast.success(res.data.message ||"Signup successful!");
    navigate("/login");
    }catch(err)
    {
      console.error("❌ API error:", err);
      toast.error(
        err.response?.data?.message ||
        ("Sign up failed")
    );
    }   
  }else
  {
    setErrors(validationErrors);
    toast.error("Fill all field carefully!");
  }
};


  return (
    <div className="min-h-screen bg-white px-8 md:px-14 xl:px-20 py-4">
      <h2 className="text-lg md:text-2xl xl:text-3xl font-bold mb-5 text-center">SIGN UP</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 xl:gap-16">
        <div className="order-2 md:order-1">
              <img src={SignUp} alt={"signup"} className="w-full h-96 md:h-[470px] xl:h-[500px] object-cover"/>
        </div>
        

      <div className="order-1 md:order-2 bg-gradient-to-br from-violet-400 to-gray-100 rounded-tl-3xl rounded-bl-[130px] md:rounded-bl-[150px] xl:rounded-bl-[200px] p-6 xl:p-7 w-full max-w-md">
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
          <input
            type="text"
            name="name"
            placeholder="Enter your Name"
            className="w-full px-4 py-2 border rounded focus:outline-none"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
          </div>

          <div>
          <input
            type="email"
            name="email"
            placeholder="Enter your Email Address"
            className="w-full px-4 py-2 border rounded focus:outline-none"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
          </div>

          <div>
          <input
            type="text"
            name="mobile"
            placeholder="Enter your Mobile Number"
            className="w-full px-4 py-2 border rounded focus:outline-none"
            value={formData.mobile}
            onChange={handleChange}
          />
          {errors.mobile && <p className="text-red-600 text-sm">{errors.mobile}</p>}
          </div>

          <div>
          <input
            type="text"
            name="address"
            placeholder="Enter address"
            className="w-full px-4 py-2 border rounded focus:outline-none"
            value={formData.address}
            onChange={handleChange}
          />
          {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}
          </div>

        <div>
         <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Enter password"
            className="w-full px-4 py-2 border rounded focus:outline-none pr-10"
            value={formData.password}
            onChange={handleChange}
          />
          <span
            className="absolute right-3 top-3 cursor-pointer text-gray-600"
            onClick={() => setShowPassword((prev) => !prev)}
            style={{ fontWeight: "bold" }}
          >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
         </div>
         {errors.password && <p className="text-red-600 text-sm">{errors.password}</p>}
        </div>

        <div>
         <div className="relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Re-enter password"
            className="w-full px-4 py-2 border rounded focus:outline-none pr-10"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
          <span
            className="absolute right-3 top-3 cursor-pointer text-gray-600"
            onClick={() => setShowConfirmPassword((prev) => !prev)}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
         </div>
        {errors.confirmPassword && <p className="text-red-600 text-sm">{errors.confirmPassword}</p>}
        </div>

          <div>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange} 
            className="border rounded px-3 py-2 w-full focus:outline-none"
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          {errors.gender && <p className="text-red-600 text-sm">{errors.gender}</p>}
        </div>

          <p className="text-xs md:text-sm xl:text-base my-4 text-center font-bold">
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-blue-600 cursor-pointer"
          >
            Login Here
          </span>
        </p>
        <div className="flex justify-center">
             <button
            type="submit"
            className=" px-5 bg-violet-700 text-white font-semibold py-2 rounded hover:bg-violet-800"
          >
            Sign Up
          </button>
        </div>
        </form>
        
       
      </div>
      </div>
     
    </div>
  );
}
